import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { InputAdornment, TextField, Checkbox, FormControlLabel, Box, CircularProgress } from "@mui/material";
import { ErrorRounded, Person, Info, VisibilityOff, Visibility } from "@mui/icons-material";
import { authActions } from "../../../../store/store";
import { useDispatch } from "react-redux";
import useTogglePassword from "../../../../hooks/useTogglePassword";
import { decryptRole } from "../../../../App";
import apiClient from "helpers/ApiClient";
import { setRouteInfoSignupFunc } from "store/features/personaldesktopslice";
import "./signinForm.scss";
import GlobalSnackBar from "UI/snackbar/GlobalSnackBar";

const SignInForm = () => {
  const [ErrorMessage, setErrorMessage] = useState("");
  const [loadingState, setLoadngState] = useState(false);
  const [toggleSnackbar, setToggleSnackbar] = useState({ message: "", isToggle: false, mode: "" });
  const [userId ,setUserId]=useState("")
  const [verificationStatus ,setVerificationStatus]=useState(false)
  const [state, toggleState]: any = useTogglePassword({
    password: false,
    confirmPassword: false,
  });

  let navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    email: "",
    password: "",
    rememberMe: false,
  };

  // ************************* General form validation
  const validate = Yup.object({
    email: Yup.string().required("Email is required.").email("Enter a valid email."),
    password: Yup.string().required("Password is required."),
  });
  const rolesList = ["Insurance Companies", "MOT Centres", "Motor Dealers", "Motor Auctioneers", "Salvage Dealers", "Finance Companies", "Fleet Operators", "Car Buying Services"];

  const loginAPI = async (email: any, password: any) => {
    const tempLoginResponse = apiClient
      .post("users/login", {
        email,
        password,
      })
      .then((response) => {
        setUserId(response.data.data?.user?.id)
        setVerificationStatus(response.data.data?.user?.verificationStatus!=="Approved")
        //  if(response.data.data?.user?.verificationStatus!=="Approved" && (response.data.data?.user?.roles[0]!=="Employee") && (response.data.data?.user?.roles[0]!=="Admin"  )){
        //   setErrorMessage("Your verification is not approved yet")
        //   return
        //  }
         
        let userId = response?.data?.data?.user?.id || "";
        let cognitoId = response?.data?.data?.user?.cognitoId || "";
        dispatch(authActions.clickedRememberMe(values.rememberMe));
        dispatch(
          authActions.login({
            user: response?.data?.data?.user,
            challengeName: response?.data?.data?.challengeName,
            sessionToken: response?.data?.data?.sessionToken,
            email: response?.data?.data?.user?.email,
            token: response?.data?.data?.token,
            id: response?.data?.data?.user?.id,
            role: response?.data?.data?.user?.roles[0],
            companyData: response?.data?.data?.user?.company,
            verificationStatus: response?.data?.data?.user?.verificationStatus,
          })
        );
        let userData = JSON.parse(localStorage.getItem("userData") || sessionStorage.getItem("userData") || "null");
        let tempRoute = JSON.parse(sessionStorage.getItem("tempRoute") || "null");

        const logoutHandler = () => {
          dispatch(authActions.clickedRememberMe(false));
          dispatch(authActions.logout());
        };

        const userRole = decryptRole(userData?.role);
        if (tempRoute) {
          navigate(tempRoute);
          sessionStorage.removeItem("tempRoute");
        } else {
          if (userRole === "Commercial") {
            if (!userData?.companyData) {
              logoutHandler();
              navigate("/authentication/signup/Commercial", { state: { userId, stepperState: 1 }, replace: true });
            } else navigate("/c-dashboard");
          }
          if (userRole === "Corporate") {
            if (!userData?.companyData) {
              logoutHandler();
              navigate("/authentication/signup/Corporate", { state: { userId, stepperState: 1 }, replace: true });
            } else navigate("/c-dashboard");
          }
          if (userRole === "Personal" || userRole === "Employee") {
            navigate("/");
          }
          if (userRole === "Admin") {
            navigate("/system-admin-dashboard");
          }
          if (rolesList.includes(userRole)) {
            if (!userData?.companyData) {
              logoutHandler();
              navigate("/authentication/third_party_signup/ThirdParty", { state: { userId, stepperState: 1 }, replace: true });
            } else navigate("/third-party-dashboard");
          }
          if (userRole === "Lawyers") {
            if (!userData?.verificationStatus) {
              logoutHandler();
              navigate("/authentication/lawyers_signup/Lawyers", { state: { userId, cognitoId, stepperState: 1 }, replace: true });
            } else if (userData?.verificationStatus === "submitted") {
              logoutHandler();
              navigate("/authentication/signIn", { state: { userId, cognitoId, stepperState: 1 }, replace: true });
              setErrorMessage("Your veriff status is pending.");
            } else navigate("/lawyers-dashboard");
          }
        }
      })
      .catch((error: any) => {
        // if (error?.response?.data?.message === "User is not confirmed.") {
        //   if (error?.response?.data?.data?.roles[0] === "Commercial") {
        //     return navigate("/authentication/signup/Commercial", { state: { userData: error?.response?.data?.data, otpScreenStatus: true }, replace: true });
        //   }
        //   if (error?.response?.data?.data?.roles[0] === "Corporate") {
        //     return navigate("/authentication/signup/Corporate", { state: { userData: error?.response?.data?.data, otpScreenStatus: true }, replace: true });
        //   }
        //   if (error?.response?.data?.data?.roles[0] === "Personal" || error?.response?.data?.data?.roles[0] === "Employee") {
        //     return navigate("/authentication/personal_signup/Personal", { state: { userData: error?.response?.data?.data, otpScreenStatus: true }, replace: true });
        //   }
        //   if (error?.response?.data?.data?.roles[0] === "Lawyers") {
        //     return navigate("/authentication/lawyers_signup/Lawyers", { state: { userData: error?.response?.data?.data, otpScreenStatus: true }, replace: true });
        //   }
        //   if (rolesList.some((role) => role === error?.response?.data?.data?.roles[0])) {
        //     return navigate("/authentication/third_party_signup/ThirdParty", { state: { userData: error?.response?.data?.data, otpScreenStatus: true }, replace: true });
        //   }
        // } else 
        setErrorMessage(error?.response?.data?.message);
      })
      .finally(() => {
        setLoadngState(false);
        return tempLoginResponse;
      });
  };

  const SignInSubmitHandler = async () => {
    setLoadngState(true);
    try {
      await loginAPI(values.email, values.password);
    } catch (_) {
      setErrorMessage("There was some server issue.");
    }
  };
  const { values, touched, errors, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: validate,
    onSubmit: SignInSubmitHandler,
  });

  useEffect(() => {
    dispatch(setRouteInfoSignupFunc(0));
  }, []);

  const handleResendEmail=async()=>{
    try{
  await apiClient.post("users/verification-create",{userId})
  setToggleSnackbar({
    message: "Check your email for verification.",
    isToggle: true,
    mode: "success",
   
  });
    }
    catch(error:any){
      setToggleSnackbar({
        message: "Something went wrong!",
        isToggle: true,
        mode: "error",
      });
    }
  }
  return (
    <Box className={`signinForm`}>
      {toggleSnackbar.isToggle && <GlobalSnackBar isOpenSnack={toggleSnackbar} setIsOpenSnack={setToggleSnackbar} />}
            <form onSubmit={handleSubmit}>
        {ErrorMessage && (
          <span className="error-color top-errorMessage">
            <ErrorRounded sx={{ marginRight: "5px" }} />
            <p>{ErrorMessage}</p>
         {verificationStatus &&  <button type="submit" className={`fs-20 fw-500 btn-primary`} style={{marginLeft:"15px"}} onClick={handleResendEmail}>verify again</button>}
          </span>
        )}
        {window.location.search === "?tokenRevoked" && (
          <span className="error-color top-errorMessage">
            <ErrorRounded sx={{ marginRight: "5px" }} />
            <p>Your access has been revoked, Please login again.</p>
          </span>
        )}
        <Box className="email-input">
          <label htmlFor="email" className={errors.email && touched.email ? "error-color" : "label-color input-label"}>
            Email
          </label>

          <TextField
            type="email"
            id="email"
            fullWidth
            variant="outlined"
            error={!!(errors.email && touched.email)}
            sx={{ backgroundColor: "#fff" }}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {errors.email && touched.email ? <Info fontSize="medium" className="error-color" /> : <Person fontSize="large" className="icon-color" />}
                </InputAdornment>
              ),
            }}
          />

          {errors.email && touched.email && <small className="error-color fs-14 email-error-reqiured">{errors.email}</small>}
        </Box>
        <Box className="email-input">
          <label htmlFor="password" className={errors.password && touched.password ? "error-color" : "input-label"}>
            Password
          </label>

          <TextField
            fullWidth
            id="password"
            type={state.password ? "text" : "password"}
            variant="outlined"
            value={values.password}
            onChange={handleChange}
            sx={{ backgroundColor: "#fff" }}
            onBlur={handleBlur}
            error={!!(errors.password && touched.password)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {state.password ? (
                    <Visibility fontSize="medium" className="cursor-pointer icon-color" onClick={() => toggleState("Password")} />
                  ) : (
                    <VisibilityOff sx={{ color: "#6C6B6B" }} fontSize="medium" className="cursor-pointer icon-color" onClick={() => toggleState("Password")} />
                  )}
                  {errors.password && touched.password && <Info fontSize="medium" className="error-color" />}
                </InputAdornment>
              ),
            }}
          />

          {errors.password && touched.password && <small className="error-color fs-14 email-error-reqiured">{errors.password}</small>}
        </Box>
        <Box className="remember-forgot">
          <FormControlLabel
            control={
              <Checkbox
                id="rememberMe"
                onChange={handleChange}
                value={values.rememberMe}
                sx={{
                  color: "#CACACA",
                  "&.Mui-checked": {
                    color: "#7fb341",
                  },
                }}
              />
            }
            label="Remember me"
            sx={{ mb: "0px" }}
          />
          <Link to="/authentication/forgot-password" className={`forgotPasswordText fw-700 fs-16 grey-color`}>
            Forgot Password?
          </Link>
        </Box>
        <Box>
          <button
            type="submit"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
            className={`signInBtn fs-20 fw-500 btn-primary`}
          >
            {loadingState ? (
              <>
                <CircularProgress size={20} sx={{ color: "#FFFFFF", mr: 1 }} />
                <span>{"  "} Loading...</span>
              </>
            ) : (
              <span>LOGIN</span>
            )}
          </button>
        </Box>
      </form>
    </Box>
  );
};
export default SignInForm;
